// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/Container/defaults.css
// module id = 888
// module chunks = 0